module.exports = " <div>seller</div> ";


//////////////////
// WEBPACK FOOTER
// ./~/_vue-html-loader@1.2.4@vue-html-loader!./~/_vue-loader@8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/_eslint-loader@1.7.1@eslint-loader!./src/components/seller/seller.vue
// module id = 21
// module chunks = 1